import times from 'lodash/times';
import random from 'lodash/random';

/**
 * Responsible for generating a random set of characters
 * @param {Object} options - Configurable options for generating a random string
 * @param {string} [options.prefix=''] - Prefix added to random characters
 * @param {string} [options.length=30] - The amount of characters
 * @returns {string} A set of randomly generated characters
 */
const generateRandom = (options = {}) => {
  const {
    prefix = '',
    length = 30,
  } = options;

  const chars = times(length, () => random(35).toString(36)).join('');

  return prefix ? `${prefix}-${chars}` : chars;
};

export default generateRandom;



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/random.js